import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { LOGO_PATH, BUSINESS_NAME } from '../../config/brand';
import { LayoutDashboard, CalendarCheck, LogOut, Scissors } from 'lucide-react';

export default function StaffLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const handleLogout = async () => { await logout(); navigate('/login'); };

  return (
    <div className="min-h-screen bg-[#F9F9F7]">
      <nav className="sticky top-0 z-50 bg-white border-b border-[#E5E5E0]">
        <div className="max-w-5xl mx-auto px-6 flex items-center justify-between h-16">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <img src={LOGO_PATH} alt={BUSINESS_NAME} className="h-9 object-contain" />
              <span className="text-xs bg-[#4A7C59] text-white px-2 py-0.5 rounded-full font-medium">Staff</span>
            </div>
            <button onClick={() => navigate('/staff/dashboard')} className={`px-4 py-2 rounded-full text-sm font-medium ${location.pathname === '/staff/dashboard' ? 'bg-[#6A3E28] text-white' : 'text-[#5A5A5A] hover:bg-[#F5EDE6]'}`} data-testid="staff-nav-dashboard">
              Dashboard
            </button>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-sm font-medium text-[#2D2D2D]">{user?.name}</span>
            <button onClick={handleLogout} className="text-[#888] hover:text-[#D9534F]" data-testid="staff-logout-btn">
              <LogOut className="w-5 h-5" strokeWidth={1.5} />
            </button>
          </div>
        </div>
      </nav>
      <main className="max-w-5xl mx-auto px-4 md:px-6 py-6"><Outlet /></main>
    </div>
  );
}
